<div class="form-group">
  <wm-de-label [entity]="entity" [for]="entity.templateCode"></wm-de-label>
    <!--added by Juber --- start -->
  @if (!templateForPermitForm) {
   <input
    type="text"
    readonly
    class="form-control-plaintext"
    [id]="entity.templateCode"
    [value]="this.todaysDate"
  />
  } 
  @else {
        <wm-common-textfield
        [data]="{
          label: '', 
          value: todaysDate,
          readonly: true,
          
        }"
      ></wm-common-textfield>
    
  }
    <!--added by Juber --- end -->
</div>
